<template>
    <f7-toolbar tabbar labels :bottom-md="true">
        <f7-link tab-link @click="go('/home','home')" text="首页" icon="home"
                 :tab-link-active="activeTabItem==='home'"></f7-link>
        <f7-link tab-link @click="go('/package/list','package')" text="下载包" icon="download"
                 :tab-link-active="activeTabItem==='package'"></f7-link>
        <f7-link tab-link @click="go('/device/list','device')" :tab-link-active="activeTabItem==='device'" icon="mange"
                 text="设备管理"></f7-link>
        <f7-link tab-link @click="airkiss" text="配网" icon="wifi"></f7-link>
    </f7-toolbar>
</template>

<script>
  import { f7Toolbar, f7Link } from 'framework7-vue'
  import { globalConst as native, modalTitle } from '../../lib/const'
  import { bus } from 'src/main'

  export default {
    name: 'baseToolbar',
    methods: {
      addDevice () {
        let that = this
        if (__DEBUG__) {
          // 1E:88:79:05:3A:86
          let macAddr = '1E:88:79:05:3A:86'
          let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
          if (!reg.test(macAddr)) {
            that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
            return
          }
          that.$store.dispatch({
            type: native.doBindDevice,
            macAddr
          }).then(() => {
            that.$store.commit('setDownLoaderServerUrl', '')
            that.$store.commit('setMacAddr', macAddr)
            bus.$emit('loadData')
          })
        } else {
          wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function (res) {
              let result = res.resultStr
              let reg = /(([a-f0-9]{2}:)|([a-f0-9]{2}-)){5}[a-f0-9]{2}/gi
              if (!reg.test(result)) {
                that.$f7.dialog.alert('MAC地址格式不正确，请扫描正确的设备MAC地址...', modalTitle)
                return
              }
              that.$store.dispatch({
                type: native.doBindDevice,
                macAddr: result
              }).then(({data}) => {
                that.$store.commit('setDownLoaderServerUrl', '')
                that.$store.commit('setMacAddr', data.macAddr)
                bus.$emit('loadData')
              })
            }
          })
        }
      },
      go (url, pageName) {
        this.$store.commit('setActiveTabbarItem', pageName)
        this.$f7router.navigate(url, {clearPreviousHistory: true})
      },
      airkiss () {
        console.log('airkiss')
        let that = this
        wx.ready(function () {
          // 在这里调用 API
          wx.invoke('configWXDeviceWiFi', {}, (res) => {
            const msg = res.err_msg
            if (msg === 'configWXDeviceWiFi:ok') {
              that.$store.commit('setDownLoaderServerUrl', '')
              bus.$emit('loadData')
            }
          })
        })
        wx.error(function (res) {
          alert('配置出错')
        })
      },
    },
    computed: {
      activeTabItem () {
        return this.$store.state.activeTabItem
      }
    },
    components: {f7Toolbar, f7Link}
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "baseToolbar.scss";
</style>